import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { formatProductName, productAlt, shopifyImg, shopifySrcSet, SIZES_GRID_4 } from "@/lib/format";

export default function ProductCard({ product }) {
  const soldOut = product.available === false;
  const hasSecond = Boolean(product.images?.[1]);

  return (
    <div data-testid={`product-card-${product.id}`} className="group">
      <Link to={`/products/${product.id}`} data-testid={`product-link-${product.id}`} className="block">
        <div className="relative aspect-[4/5] bg-[#141414] overflow-hidden mb-4 border border-[#8A8A8A]/10">
          {product.images?.[0] ? (
            <>
              <img
                src={shopifyImg(product.images[0], 720)}
                srcSet={shopifySrcSet(product.images[0])}
                sizes={SIZES_GRID_4}
                width="720"
                height="900"
                alt={productAlt(product)}
                className={`w-full h-full object-cover transition-all duration-700 ${hasSecond ? "group-hover:opacity-0" : "group-hover:scale-105"} ${soldOut ? "opacity-40" : "opacity-95"}`}
                loading="lazy"
              />
              {hasSecond && (
                <img
                  src={shopifyImg(product.images[1], 720)}
                  srcSet={shopifySrcSet(product.images[1])}
                  sizes={SIZES_GRID_4}
                  width="720"
                  height="900"
                  alt={productAlt(product, "detail view")}
                  className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700"
                  loading="lazy"
                />
              )}
            </>
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[#8A8A8A]/30">
              <ShoppingBag size={32} strokeWidth={1} />
            </div>
          )}
          {soldOut && (
            <div data-testid={`sold-out-${product.id}`} className="absolute inset-0 z-10 flex items-center justify-center bg-black/55">
              <div className="w-full bg-[#0A0A0A]/85 border-y border-[#F2F0EB]/25 py-2 sm:py-2.5">
                <span className="block text-center font-['Oswald'] text-sm sm:text-lg font-bold uppercase tracking-[0.3em] text-[#F2F0EB]">Sold Out</span>
              </div>
            </div>
          )}
        </div>
      </Link>
      <Link to={`/products/${product.id}`}>
        <h3 className="font-['Oswald'] text-xs sm:text-sm font-medium uppercase tracking-[0.15em] text-[#F2F0EB] truncate">
          {formatProductName(product)}
        </h3>
      </Link>
      <p className="text-xs sm:text-sm text-[#8A8A8A] tracking-[0.1em] mt-1.5">${product.price?.toFixed(2)}</p>
    </div>
  );
}
